import * as yup from 'yup';
import * as errorMessage from '../constants/ErrorMessages';
import { REGEX_MAIL_VALIDATION } from '../constants/common';

export const nomineeDetailsValidation = (accountHolder?: string, documentName?: string, panException?: boolean) =>
  yup.object().shape({
    name: yup.string().required(errorMessage.NOMINEE_NAME_ERROR).nullable(true),
    relationShip: yup.string().required(errorMessage.NOMINEE_RELATIONSHIP_ERROR).nullable(true),
    dateOfBirth: yup.date().required(errorMessage.NOMINEE_DOB_ERROR).nullable(true),
    email: yup
      .string()
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|org|net|co\.in)$/, errorMessage.EMAIL_ERROR)
      .required(errorMessage.EMAIL_ERROR)
      .nullable(true),
    city: yup
      .string()
      .matches(/^.{3,34}$/, 'Enter a valid city name')
      .required('Enter a valid city name')
      .nullable(true),
    documentType: yup.string().required('Select a document').nullable(true),
    // documentNumber: yup
    //   .string()
    //   .matches(
    //     panException
    //       ? /^[a-zA-Z0-9]+$/
    //       : documentName === 'PAN'
    //       ? /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/
    //       : documentName === 'AADHAAR'
    //       ? /^\d{4}$/
    //       : documentName === 'Driving License'
    //       ? /^[0-9]{8,15}$/
    //       : documentName === 'Passport'
    //       ? /^.{5,30}$/
    //       : /^[A-Z]{1,2}[0-9]{7}$/,
    //     'Enter valid details'
    //   )
    //   .required('Enter valid details')
    documentNumber: yup
      .string()
      .when('documentType', (docType, schema) => {
        switch (docType) {
          case 'PAN':
            return schema
              .matches(/^[a-zA-Z]{3}[P,T][a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$/, 'Enter valid details')
              .required('Enter valid details');
          case 'AADHAAR':
            return schema
              .matches(/^\d{4}$/, 'Please enter the last 4 digits')
              .required('Please enter the last 4 digits');
          case 'Driving License':
            return schema.matches(/^[a-zA-Z0-9]{8,15}$/, 'Enter valid details').required('Enter valid details');
          case 'Passport':
            return schema.matches(/^[a-zA-Z0-9]{8,30}$/, 'Enter valid details').required('Enter valid details');
        }
      })
      .nullable(true),
    address: yup
      .string()
      .matches(/^.{15,200}$/, 'Enter valid details (Minimum 15 characters)')
      .required('Enter valid details (Minimum 15 characters)')
      .nullable(true),
    country: yup.string().required('Choose an option').nullable(true),
    pinCode: yup
      .string()
      .matches(/^\d{6}$/, 'Enter a valid pincode')
      .required('Enter a valid pincode')
      .nullable(true),
    phone: yup
      .string()
      .matches(/^\d{10,15}$/, 'Enter a valid mobile number')
      .required('Enter a valid mobile number')
      .nullable(true),
    nreFlag: yup.string().required('Select an option'),
  });

export const guardianDetailsValidation = (accountHolder?: string) =>
  yup.object().shape({
    name: yup.string().required(errorMessage.GUARDIAN_NAME_ERROR).nullable(true),
    relationShip: yup.string().required(errorMessage.NOMINEE_RELATIONSHIP_ERROR).nullable(true),
    dateOfBirth: yup.date().required(errorMessage.NOMINEE_DOB_ERROR).nullable(true),
  });

export const isUnitRequired = (Units: string, minUnit: number, totalUnits: number) =>
  yup.number().when('partialOptions', {
    is: Units,
    then: yup
      .number()
      .when('cardUsedIn', {
        is: 'Switch',
        then: yup.number().min(minUnit, errorMessage.MINIMUM_SWITCH_UNITS_ERROR(minUnit)),
        otherwise: yup.number().min(minUnit, errorMessage.MINIMUM_REDEEM_UNITS_ERROR(minUnit)),
      })
      .when('isElssOrCloseScheme', {
        is: false,
        then: yup.number().lessThan(totalUnits, errorMessage.MAX_UNITS_ERROR),
      })
      .required(errorMessage.UNITS_ERROR),
    otherwise: yup.number().notRequired(),
  });

export const isAmountRequired = (Amount: string, minAmount: number, currentValue: number) =>
  yup.number().when('partialOptions', {
    is: Amount,
    then: yup
      .number()
      .when('cardUsedIn', {
        is: 'Switch',
        then: yup.number().min(minAmount, errorMessage.MINIMUM_SWITCH_AMOUNT_ERROR(minAmount)),
        otherwise: yup.number().min(minAmount, errorMessage.MINIMUM_REDEEM_AMOUNT_ERROR(minAmount)),
      })
      .lessThan(currentValue, errorMessage.MAX_AMOUNT_ERROR)
      .required(errorMessage.AMOUNT_ERROR),
    otherwise: yup.number().notRequired(),
  });

export const isAmountOrUnitRequired = (
  OneTime: string,
  full: string,
  isUnit: boolean,
  Units: string,
  minUnit: number,
  totalUnits: number,
  Amount: string,
  minAmount: number,
  currentValue: number,
  minimumUnits: number,
  minimumAmount: number
) =>
  yup.number().when('oneTimeOrSystematic', {
    is: OneTime,
    then: yup.number().when('fullOrPartial', {
      is: full,
      then: yup.number().notRequired(),
      otherwise: isUnit
        ? isUnitRequired(Units, minUnit, totalUnits)
        : isAmountRequired(Amount, minAmount, currentValue),
    }),
    otherwise: isUnit
      ? isUnitRequired(Units, minimumUnits, totalUnits)
      : isAmountRequired(Amount, minimumAmount, currentValue),
  });
